import Layout from '@/layout';
import { roterPre } from '@/settings';
var assetRouter = {
  path: "".concat(roterPre, "/asset"),
  name: 'asset',
  meta: {
    icon: 'money',
    title: '资产管理'
  },
  alwaysShow: true,
  component: Layout,
  children: [{
    path: 'list',
    name: 'MerchantAssetManage',
    meta: {
      title: '商户资产管理',
      noCache: true
    },
    component: function component() {
      return import('@/views/asset/index');
    }
  }]
};
export default assetRouter;